export const SupplierAdminErrorOffset = 500_000;

